<template src="./Employee.html" />

<script>
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"

export default {
  name: "Employee"  ,
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      invalidFields: {
        name: { required: false, digits: false },
        email: false,
        cpf: false,
        phone: false,
        signatureSelected: false,
      },
      titleCard: `Cadastrar novo ${this.isProject ? 'funcionário': 'paciente'}`,
      genderOptions: [
        { text: "Feminino", value: "F" },
        { text: "Masculino", value: "M" }
      ],
      name: null,
      email: null,
      gender: null,
      dateBirth: null,
      rg: null,
      cpf: null,
      phone: null,
      address: {
        id: "",
        zipcode: "",
        city: "",
        complement: "",
        state: "",
        street: "",
        number: ""
      },
      disable: {
        city: true,
        state: true,
        street: false
      },
      saveClicked: false,
      oscs:[],
      osc: null,
      signatureList: [],
      signatureSelected: null
    };
  },
  watch: {
    name: function () {
      const value = (this.name || "").trim()
      const hasDigits = /\d/.test(value)

      this.invalidFields.name.required = !value && this.saveClicked
      this.invalidFields.name.digits = hasDigits && this.saveClicked
    },
    cpf: function () {
      this.invalidFields.cpf = !this.validateCPF(this.cpf) && this.saveClicked
    },
    email: function () {
      this.invalidFields.email = !this.validateEmail(this.email) && this.saveClicked
    },
    phone: function () {
      this.invalidFields.phone = !this.phone && this.saveClicked
    },
    signatureSelected () {
      this.invalidFields.signatureSelected = !this.signatureSelected
    }
  },
  computed: {
    isProject() {
      return this.$session.get("isProject") ? this.$session.get("isProject") : false
    },
  },
  setup () {
    const store = useStore()

    return {
      getCompanySignaturesList: (id) => store.dispatch("getCompanySignaturesList", id),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  async mounted () {
    if (this.isProject) {
      this.getOSCs()
    }

    const signatureList = await this.getCompanySignaturesList(this.$route.params.id)
      
    this.signatureList = signatureList.map((signature) => ({
      ...signature,
      name_code: `${signature.name} (${signature.code})`,
    }))
  },
  methods: {
    getOSCs() {
      this.axios.get(`${this.$store.state.filooServer}clinic-project/project-osc`)
        .then(({ status, data }) => {
          if (status === 200) {
            this.oscs = data
          }
        })
    },
    async getAddressData(zipcode) {
      const response = await this.getAddressByZipcode(zipcode)
      if (response.status === 200) {
        this.address.city = response.address.city
        this.address.state = response.address.state
        this.address.street = response.address.street
        this.disable.street = !this.address.street
      }
    },
    validateFields() {
      this.saveClicked = true

      const value = (this.name || "").trim()
      this.invalidFields.name.required = !value
      this.invalidFields.name.digits = /\d/.test(value)

      this.invalidFields.signatureSelected = !this.signatureSelected
      this.invalidFields.phone = !this.phone
      this.invalidFields.email = !this.validateEmail(this.email)
      this.invalidFields.cpf = !this.validateCPF(this.cpf)
      
      const hasInvalids = Object.values(this.invalidFields).some((val) =>
        typeof val === 'object' ? Object.values(val).some(Boolean) : val
      )

      if (hasInvalids) {
        this.$vs.notify({
          title: "Atenção",
          text: 'Campos obrigatórios não preenchidos ou inválidos',
          color: "warning",
          position: "top-right"
        })
      } else {
        this.postEmployee()
      }
    },

    postEmployee(){
      let employee = {
        name: this.name,
        email: this.email,
        phone: this.phone.replace(/[^\d]+/g,''),
        gender: this.gender ? this.gender.value : null,
        rg: this.rg,
        cpf: this.cpf.replace(/[^\d]+/g,''),

        address: this.address,
        birthdate: this.dateBirth,
        b2b: true,
        osc: this.osc,
        customerPlanId: this.signatureSelected.id
      }
      this.axios.defaults.headers.common["Authorization"] = this.$session.get(
        "bearer"
      );
      this.axios.post(`${this.$store.state.filooServer}company/employees`, employee)
        .then(({ status }) => {
          if (status == 200) {
            this.$swal({
              title: "Sucesso!",
              text: "Dados registrados com sucesso.",
              icon: "success"
            });
          }
        })
        .catch((error ) => {
          const status = error.response.status;
          if (status === 409) {
            this.$swal({
              title: "Atenção!",
              text: error.response.data.message,
              icon: "error"
            });
          }
          if(status === 500) {
            this.$swal({
              title: "Atenção!",
              text: "Não foi possível realizar esta operação contacte o administrador do sistema.",
              icon: "error"
            });
          }
        });
    },
  }
};
</script>

<style lang="scss" src="./Employee.scss" scoped />
